import getAPIErrorMessage from './getAPIErrorMessage'

export default getAPIErrorMessage
